import {
  login
} from '@/api/login'
import { mapGetters } from 'vuex'
import { decode } from 'js-base64'
import LZString from 'lz-string'
import baseUrl from '@/utils/baseUrl'
export default {
  data() {
    return {
      baseURL: baseUrl,
      clientIp: ''
    }
  },
  computed: {
    ...mapGetters(['token', 'language', 'brand'])
  },
  created() {
    this.ensureClientIp()
    const { query } = this.$route
    // console.log(query)
    if (!query.sessionId) {
      if (query.credential) {
        const { sessionId } = JSON.parse(decode(query.credential))
        query.sessionId = sessionId
      } else query.sessionId = this.token
    }
    if (!query.language) query.language = this.language
    const lang = query.language && (query.language === 'en_US' || query.language === 'en') ? 'en' : 'zh'
    const redirect = query.redirect ? decodeURI(query.redirect) : ''
    this.setLanguage(lang)
    const brand = query.brand ? decodeURI(query.brand) : ''
    this.$store.dispatch('app/setBrand', brand)
    let decodeTracking = ''
    if (query.trackNos) {
      decodeTracking = LZString.decompressFromEncodedURIComponent(query.trackNos)
    }
    this.$store.dispatch('user/set_trackingNo', decodeTracking)
    this.$store.dispatch('user/clearStroage').then(() => {
      if (query.sessionId) {
        this.$store.dispatch('user/set_token', query.sessionId)
        this.getUserInfo(query.sessionId, redirect)
      } else this.toGoRouter()
    })
  },
  methods: {
    getLoginExtraParams() {
      const STORAGE_KEY = 'clientId'
      let fingerPrint = localStorage.getItem(STORAGE_KEY)

      return {
        hostname: window.location.hostname,
        ip: this.clientIp,
        fingerPrint
      }
    },
    async ensureClientIp() {
      if (this.clientIp) return
      const fetchIp = url => fetch(url).then(res => res.json()).then(data => data.ip)
      try {
        this.clientIp = await Promise.any([
          fetch('https://ipv4.icanhazip.com/').then(res => res.text()).then(text => text.trim()),
          fetchIp('https://api.ipify.org?format=json')
        ]) || ''
      } catch {
        this.clientIp = ''
      }
    },
    // 获取用户信息
    async getUserInfo(sessionId, redirect) {
      await this.ensureClientIp()
      login(this.baseURL, { sessionId: sessionId, ...this.getLoginExtraParams() }).then(res => {
        if (res.code !== '0') {
          this.$store.dispatch('user/resetToken').then(() => {
            this.toGoRouter()
          })
          return
        }
        const obj = { ...res.data }
        // 重新赋值用户信息
        this.$store.dispatch('user/set_userInfo', obj).then((userInfo) => {
          if (redirect) {
            this.$router.push({ path: redirect })
          } else {
            this.toGoRouter()
          }
        })
      })
    },
    // 设置系统语言
    setLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
    },
    // 跳转对应项目
    toGoRouter() {
      switch (this.brand) {
        case 'UBI':
          this.$router.push({ path: '/ubi' })
          break
        case 'UBI_SPWW':
          this.$router.push({ path: '/spww' })
          break
        default:
          // eTowe的通用查件
          this.$router.push({ path: '/home' })
          break
      }
    }
  }
}
